import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import FileTextRegular from './file-text-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FileTextRegular {...validProps} />;
}

SvgComponent.iconName = 'fileTextRegular';

export const FileTextRegularIcon = svgIconWrapper(SvgComponent);
